import { render, staticRenderFns } from "./CheckShippingCostComponent.vue?vue&type=template&id=6491589c&"
import script from "./CheckShippingCostComponent.vue?vue&type=script&lang=js&"
export * from "./CheckShippingCostComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports